<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="collaboration-options">
    <div class="container">

        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">Cum pot să devin colaborator Propero?</h3>
                    <p class="text">Alege modul de colaborare care ți se potrivește și începe să-ți gestionezi
                        proprietățile mai
                        eficient</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 mb-4">
                <div class="management-card self-managed">
                    <div class="card-header">
                        <div class="icon-wrapper">
                            <i class="lni lni-user"></i>
                        </div>
                        <h2>Proprietari</h2>
                        <p>Gestionați-vă proprietățile în mod independent cu instrumentele noastre profesionale</p>
                    </div>
                    <div class="card-content">
                        <h3 class="section-title">Cum funcționează?</h3>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <div class="step-content">
                                    <h4>Creare cont</h4>
                                    <p>Înregistrați-vă gratuit și configurați-vă profilul</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <div class="step-content">
                                    <h4>Adăugare proprietăți</h4>
                                    <p>Încărcați detaliile și fotografiile proprietăților</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <div class="step-content">
                                    <h4>Gestionare chiriași</h4>
                                    <p>Administrați contracte și comunicați cu chiriașii</p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-sections">
                            <div class="benefits">
                                <h3>Beneficii</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Control total asupra proprietăților</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Instrumente profesionale de management</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Suport tehnic dedicat</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="offerings">
                                <h3>Ce oferim</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Dashboard personalizat</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Rapoarte și analize</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Notificări automate</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="cta-button">
                            <a href="https://propero.io/login" target="_blank" class="btn btn-primary">Începeți Acum</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="management-card delegated">
                    <div class="card-header">
                        <div class="icon-wrapper">
                            <i class="lni lni-consulting"></i>
                        </div>
                        <h2>Propero Management</h2>
                        <p>Lăsați gestionarea proprietăților în mâinile experților noștri</p>
                    </div>
                    <div class="card-content">
                        <h3 class="section-title">Cum funcționează?</h3>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <div class="step-content">
                                    <h4>Consultare inițială</h4>
                                    <p>Evaluăm nevoile și stabilim strategia</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <div class="step-content">
                                    <h4>Preluare proprietăți</h4>
                                    <p>Ne ocupăm de toate aspectele administrative</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <div class="step-content">
                                    <h4>Management activ</h4>
                                    <p>Gestionăm totul în numele dumneavoastră</p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-sections">
                            <div class="benefits">
                                <h3>Beneficii</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Management profesionist</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Economie de timp</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Maximizarea profitului</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="offerings">
                                <h3>Ce oferim</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Servicii complete de management</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Verificare chiriași</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Asistență 24/7</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="cta-button">
                            <a href="https://propero.io/login" target="_blank" class="btn btn-primary">Contactați-ne</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="management-card admin">
                    <div class="card-header">
                        <div class="icon-wrapper">
                            <i class="lni lni-home"></i>
                        </div>
                        <h2>Administratori de imobile</h2>
                        <p>Gestionați eficient portofoliul de proprietăți cu instrumente dedicate</p>
                    </div>
                    <div class="card-content">
                        <h3 class="section-title">Cum funcționează?</h3>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <div class="step-content">
                                    <h4>Configurare portofoliu</h4>
                                    <p>Adăugați toate imobilele și unitățile administrate</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <div class="step-content">
                                    <h4>Organizare activități</h4>
                                    <p>Planificați și urmăriți toate activitățile de administrare</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <div class="step-content">
                                    <h4>Management complet</h4>
                                    <p>Gestionați cheltuieli, întreținere și comunicare</p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-sections">
                            <div class="benefits">
                                <h3>Beneficii</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Automatizare procese administrative</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Gestionare eficientă a costurilor</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Comunicare centralizată</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="offerings">
                                <h3>Ce oferim</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Platformă specializată pentru administrare</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Instrumente de raportare avansată</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Asistență tehnică permanentă</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="cta-button">
                            <a href="#contact" class="btn btn-primary">Contactați-ne</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="management-card agency">
                    <div class="card-header">
                        <div class="icon-wrapper">
                            <i class="lni lni-apartment"></i>
                        </div>
                        <h2>Agenții imobiliare</h2>
                        <p>Creșteți-vă afacerea cu soluția noastră white-label</p>
                    </div>
                    <div class="card-content">
                        <h3 class="section-title">Cum funcționează?</h3>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <div class="step-content">
                                    <h4>Personalizare brand</h4>
                                    <p>Configurați platforma cu identitatea dvs. vizuală</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <div class="step-content">
                                    <h4>Domeniu propriu</h4>
                                    <p>Folosiți propriul domeniu sau subdomeniu</p>
                                </div>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <div class="step-content">
                                    <h4>Lansare rapidă</h4>
                                    <p>Începeți să folosiți platforma imediat</p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-sections">
                            <div class="benefits">
                                <h3>Beneficii</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Soluție white-label completă</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Personalizare avansată</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Integrare cu sistemele existente</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="offerings">
                                <h3>Ce oferim</h3>
                                <ul>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Website personalizat</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Sistem de management proprietăți</span>
                                    </li>
                                    <li>
                                        <i class="lni lni-checkmark-circle"></i>
                                        <span>Suport tehnic dedicat</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="cta-button">
                            <a href="#contact" class="btn btn-primary">Contactați-ne</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'FOOTER.COLLABORATION_TITLE' | translate }}</h3>
                    <p class="text">{{ 'FOOTER.COLLABORATION_TEXT' | translate }}</p>
                </div>
                <div class="collaboration-content">
                    <div class="benefits-section">
                        <h4 class="section-subtitle">{{ 'FOOTER.COLLABORATION_BENEFITS_TITLE' | translate }}</h4>
                        <div class="benefits-grid">
                            <div class="benefit-item">
                                <i class="lni lni-target"></i>
                                <h5>{{ 'FOOTER.COLLABORATION_BENEFIT_1_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_BENEFIT_1_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-network"></i>
                                <h5>{{ 'FOOTER.COLLABORATION_BENEFIT_2_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_BENEFIT_2_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-grow"></i>
                                <h5>{{ 'FOOTER.COLLABORATION_BENEFIT_3_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_BENEFIT_3_DESC' | translate }}</p>
                            </div>
                            <div class="benefit-item">
                                <i class="lni lni-handshake"></i>
                                <h5>{{ 'FOOTER.COLLABORATION_BENEFIT_4_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_BENEFIT_4_DESC' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="partners-section">
                        <h4 class="section-subtitle">{{ 'FOOTER.COLLABORATION_PARTNERS_TITLE' | translate }}</h4>
                        <div class="partners-grid">
                            <div class="partner-card">
                                <img src="assets/images/partners/partner-1.png" alt="Partner 1">
                                <h5>{{ 'FOOTER.COLLABORATION_PARTNER_1_NAME' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_PARTNER_1_DESC' | translate }}</p>
                                <a href="#" class="learn-more">{{ 'FOOTER.COLLABORATION_LEARN_MORE' | translate }}</a>
                            </div>
                            <div class="partner-card">
                                <img src="assets/images/partners/partner-2.png" alt="Partner 2">
                                <h5>{{ 'FOOTER.COLLABORATION_PARTNER_2_NAME' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_PARTNER_2_DESC' | translate }}</p>
                                <a href="#" class="learn-more">{{ 'FOOTER.COLLABORATION_LEARN_MORE' | translate }}</a>
                            </div>
                            <div class="partner-card">
                                <img src="assets/images/partners/partner-3.png" alt="Partner 3">
                                <h5>{{ 'FOOTER.COLLABORATION_PARTNER_3_NAME' | translate }}</h5>
                                <p>{{ 'FOOTER.COLLABORATION_PARTNER_3_DESC' | translate }}</p>
                                <a href="#" class="learn-more">{{ 'FOOTER.COLLABORATION_LEARN_MORE' | translate }}</a>
                            </div>
                        </div>
                    </div> -->
                    <div class="contact-section">
                        <div class="contact-card">
                            <div class="contact-content">
                                <h4>{{ 'FOOTER.COLLABORATION_CONTACT_TITLE' | translate }}</h4>
                                <p>{{ 'FOOTER.COLLABORATION_CONTACT_TEXT' | translate }}</p>
                                <a href="mailto:sales@propero.io" class="btn btn-primary">
                                    {{ 'FOOTER.COLLABORATION_CONTACT_BUTTON' | translate }}
                                </a>
                            </div>
                            <div class="contact-image">
                                <img src="assets/images/collaboration/contact.jpg" alt="Contact">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'HOME.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'HOME.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required email>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'HOME.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'HOME.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <button type="submit" class="features-btn"
                                        [disabled]="contactForm.invalid || isLoading"
                                        [ngClass]="{'loading': isLoading}">
                                        <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                                        <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>